import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import useMediaQuery from '../hooks/useMediaQuery';
import NavItem from './navigation/NavItem';
import MobileNav from './navigation/MobileNav';
import { NAV_ITEMS } from '../constants/navigation';
import { LAYOUT } from '../styles/constants';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useLanguage();
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div className="w-full flex justify-center mb-4">
      <div 
        className="w-full flex justify-center"
        style={{ maxWidth: LAYOUT.WEBSITE_WIDTH }}
      >
        <div className="w-full">
          <div className="max-w-[1762px] mx-auto px-4">
            <nav className="flex justify-between lg:justify-end items-center">
              {/* Mobile Menu Button */}
              <button
                className="lg:hidden p-2"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>

              {/* Desktop Navigation */}
              <div className="hidden lg:flex gap-2">
                {NAV_ITEMS.map((item) => (
                  <NavItem key={item.key} href={item.href}>
                    {t(item.key)}
                  </NavItem>
                ))}
              </div>

              {/* Mobile Navigation */}
              <MobileNav
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
                items={NAV_ITEMS}
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;